export class AuthenticationSettings {
  production: boolean;
  issuer_uri: string;
  client_id: string;
  redirect_uri: string;
  prompt: string;
  access_type: string;
  constructor() {
    const settings = JSON.parse(localStorage.getItem('settings'));
    return settings ? settings.authenticationSettings : null;
  }
}



// WEBPACK FOOTER //
// ./src/opc/shared/models/Authenticationsettings.model.ts